import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {MAX_CARD_IMAGE_WIDTH} from '../../../components/Issuing/dimensions';

export const defaultCardParameter = 'default-card' as const;
export const cardSwitchingParameter = 'card-switching' as const;
export const showSpendControlsParameter = 'show-spend-controls' as const;

const issuingCardParams = [
  defaultCardParameter,
  cardSwitchingParameter,
  showSpendControlsParameter,
] as const;

type IssuingCardParams = (typeof issuingCardParams)[number];
export type IssuingCardHtmlParams = Partial<Record<IssuingCardParams, string>>;

export const IssuingCardConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "issuingCard" */
      '../../../components/Issuing/IssuingCard'
    ),
  htmlAttributes: {
    [defaultCardParameter]: {
      isInternal: false,
    },
    [cardSwitchingParameter]: {
      isInternal: false,
    },
    [showSpendControlsParameter]: {
      isInternal: false,
    },
  },
  customHtmlElementMethods: {
    setDefaultCard: {
      type: 'AttributeSettingMethod',
      attribute: defaultCardParameter,
      isInternal: false,
      description: 'Sets the default card to display',
    },
    setCardSwitching: {
      type: 'AttributeSettingMethod',
      attribute: cardSwitchingParameter,
      isInternal: false,
      description: 'Controls displaying the card switching UI.',
    },
    setShowSpendControls: {
      type: 'AttributeSettingMethod',
      attribute: showSpendControlsParameter,
      isInternal: false,
      description: 'Controls displaying the spend controls UI.',
    },
    setFetchEphemeralKey: {
      type: 'SupplementalFunction',
      objectToSet: 'fetchEphemeralKey',
      isInternal: false,
      description:
        'Sets the function to fetch an ephemeral key for the card to display PCI specific information for the card (like the entirety of the card number).',
    },
  },
  releaseState: 'ga',
  sentryTeam: 'baas_growth',
  teamOwner: 'baas-growth',
  maxWidth: MAX_CARD_IMAGE_WIDTH,
  description:
    'Displays a card in a Card UI - allows for switching to other cards, activation and deactivation of cards.',
  friendlyName: 'Issuing card',
  docSitePath: '/connect/supported-embedded-components/issuing-card',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-issuing-card-i-rc',
    rcTestUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-issuing-card-i-rc',
  },
};
